import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__ from "date-fns";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__format_duration_js_0e5b0024__ from "./format-duration.js";
function TimeAgo({ isShort = false, levels = 3, ...props }) {
    const date = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        if ('date' in props) return new Date(props.date);
        if ('timeAgoMs' in props) return new Date(Date.now() - props.timeAgoMs);
        return new Date();
    }, [
        props
    ]);
    const text = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>{
        const duration = (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.intervalToDuration)({
            start: date,
            end: Date.now()
        });
        return (0, __WEBPACK_EXTERNAL_MODULE__format_duration_js_0e5b0024__.formatDuration)(duration, {
            isShort,
            levels
        });
    }, [
        date,
        isShort,
        levels
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        title: date.toUTCString(),
        children: text
    });
}
export { TimeAgo };

//# sourceMappingURL=index.js.map